import { render, staticRenderFns } from "./event-categories-program.vue?vue&type=template&id=67a884ce&"
import script from "./event-categories-program.vue?vue&type=script&lang=js&"
export * from "./event-categories-program.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports